module.exports = __webpack_public_path__ + "static/home_cards-c2efa7177ba402191eaa10f5dde745f3.png";